import React from "react";
import { makeStyles, withStyles } from "@material-ui/core";
import {
    Grid,
    Typography,
    Button
} from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { useState } from "react";
import { useSelector } from "react-redux";
import { store } from "../../../helpers/store";
import { useEffect } from "react";
import { history } from "../../../helpers/index";
import { routePaths } from "../../config/route-paths";
import { adminService } from "../../../services/admin.service"
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
    title: {
        color: theme.palette.ePrimary.base,
        fontWeight: 500,
    },
    content:{
        color: theme.palette.eRich.base,
    },
    padd: {
        padding: "6%",
        textAlign: "center",
    },
    forgotPasswordBtn: {
        textTransform: "none",
        fontSize: "0.8rem",
        color: theme.palette.ePrimary.base,
        "&:hover":{
            color:theme.palette.ePrimary.hover
        },
        backgroundColor: "transparent",
        border: "none",
        cursor: "pointer",
        textDecoration: "underline",
        display: "inline",
        margin: 0,
        padding: 0,
        "& .MuiSvgIcon-root": {
            fontSize: "0.8rem !important",
            height: "0.6rem"
        }
    },
    mainDiv: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      [theme.breakpoints.up("sm")]: {
        height: "29rem",
      },
      [theme.breakpoints.up("md")]: {
        height: "24rem",
      },
    }
}));
export default function ERegisterSuccess(props) {
    const classes = useStyles();
    let path = props?.location?.state?.path;
    
    const { t: labels, ready: labelReady } = useTranslation("label-E_REGISTER_SUCCESS");
    const { t: content, ready: contentReady } = useTranslation("content-E_ACTIVATE_ACCOUNT");
    const registerSucces = useSelector(
        (state) => state?.parametersWidgets?.ParameterLookup?.E_REGISTER_SUCCESS
    )
    const languageCode = useSelector(
        (state) =>
            state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
    );

    const [successText, setSuccessText] = useState("");
    useEffect(() => {
        if(path === routePaths.FORGOT_PASSWORD) {
            setSuccessText(labels("E_FORGOT_PASSWORD_SUCCESS_TEXT"));
        } else {
            setSuccessText(labels("E_REGISTER_SUCCESS_TEXT"));
        }
    }, [props, languageCode, labelReady])
    
    const backtologin = (e) => {
        e.preventDefault();
        history.push(routePaths.LOGIN)
    }
    return (
        <div className={classes.mainDiv}>
            {labelReady ? <Grid container spacing={2} justify="center" className={classes.padd}>
                <Grid item xs={12}>
                    <Typography className={classes.title}>{successText}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Button
                        className={classes.forgotPasswordBtn}
                        onClick={backtologin}
                        variant="caption"
                    >
                        <span>  <ArrowBackIosIcon className={classes.img} /> {labels("E_BACK_TO_LOGIN_LINK")}</span>
                    </Button>
                </Grid>
            </Grid> : null
            }
        </div>
    )
}